//路由配置文件
import Order from "../page/Order"
import Detail from "../page/Detail"
import Login from "../page/Login"
import UserCenter from "../page/UserCenter"
import ResultPage from "../page/UserCenter"
const route =  [
    {path:'/',element:<Order/>},
    {path:'/order',element:<Order/>},
    {path:'/detail',element:<Detail/>},
    {path:'/login',element:<Login/>},
    {path:'/userCenter',element:<UserCenter/>},
    {path:'/resultPage',element:<ResultPage/>}, 
]
export default route;